"use client";

import type { Session } from "next-auth";
import { SessionProvider } from "next-auth/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { getSession } from "@/entities/auth";
import { AppErrorBoundary } from "./ErrorBoundary";
import { usePathname } from "next/navigation";

const SessionContent = createContext<Session | null>(null);

interface Props { children: ReactNode; }

export const Providers = ({ children }: Props) => {
  const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnMount: false, refetchOnWindowFocus: false, staleTime: 30_000, gcTime: 600_000 } } });
  const pathname = usePathname();
  const [session, setSession] = useState<Session | null>(null);

  useEffect(() => {
    getSession().then(res => setSession(res));
  }, [pathname]);

  return (
    <AppErrorBoundary>
      <SessionProvider basePath="/v2/api/auth">
        <SessionContent.Provider value={session}>
          <QueryClientProvider client={queryClient}>
            {children}
          </QueryClientProvider>
        </SessionContent.Provider>
      </SessionProvider>
    </AppErrorBoundary>
  );
};

export const useSession = () => useContext(SessionContent);